import { useState } from 'react';
import Navbar from '../home_page/navbar';
import Footer from '../home_page/footer';
import './internship_form.css';
import axios from 'axios';
import { constants } from '../../constants';
import { showToast } from './toast'; // NEW: toast notifications

function MembershipForm() {
  const [emailAdd, setEmailAdd] = useState('');
  const [phoneNum, setPhoneNum] = useState('');
  const [name, setName] = useState('');
  const [gender, setGender] = useState('');
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [aadhaarCard, setAadhaarCard] = useState('');
  const [dob, setDob] = useState('');
  const [error, setError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [dobError, setDobError] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [paymentPhoto, setPaymentPhoto] = useState('');
  const [nameError, setNameError] = useState('');
  const [genderError, setGenderError] = useState('');
  const [aadhaarError, setAadhaarError] = useState('');

  // OTP Verification
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [otp, setOtp] = useState('');
  const [otpMessage, setOtpMessage] = useState('');

  // Academic
  const [status, setStatus] = useState('');
  const [institution, setInstitution] = useState('');
  const [fieldOfStudy, setFieldOfStudy] = useState('');
  const [yearOfStudy, setYearOfStudy] = useState('');

  // Location
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [country, setCountry] = useState('');
  const [pinCode, setPinCode] = useState('');

  // Motivation
  const [whyJoin, setWhyJoin] = useState('');
  const [howContribute, setHowContribute] = useState('');
  const [areasOfInterest, setAreasOfInterest] = useState('');

  // Membership
  const [membershipCategory, setMembershipCategory] = useState('');

  // Error handling for academic, location, and motivation
  const [statusError, setStatusError] = useState('');

  const [institutionError, setInstitutionError] = useState('');
  const [fieldOfStudyError, setFieldOfStudyError] = useState('');
  const [yearOfStudyError, setYearOfStudyError] = useState('');
  const [cityError, setCityError] = useState('');
  const [stateError, setStateError] = useState('');
  const [countryError, setCountryError] = useState('');
  const [pinCodeError, setPinCodeError] = useState('');
  const [whyJoinError, setWhyJoinError] = useState('');
  const [howContributeError, setHowContributeError] = useState('');
  const [areasOfInterestError, setAreasOfInterestError] = useState('');
  const [membershipCategoryError, setMembershipCategoryError] = useState('');
  const [paymentPhotoError, setPaymentPhotoError] = useState('');

  //submission
  const [isSubmitting, setIsSubmitting] = useState(false);

  const today = new Date();
  today.setFullYear(today.getFullYear() - 12); // subtract 12 years
  const maxAllowedDate = today.toISOString().split('T')[0];

  const handleEmailVerify = async (e) => {
    e.preventDefault();
    let isValid = true;
    if (emailAdd.trim() === '') {
      setEmailError('Email cannot be empty');
      return;
    }

    try {
      const requestOtpUrl = `${constants.baseUrl}/api/auth/request-otp`;
      const response = await axios.post(
        requestOtpUrl,
        {
          otpFor: 'membership', // REQUIRED CHANGE
          email: emailAdd,
        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );
      console.log(response.data);
      if (response.data.message === 'OTP sent to your email') {
        setShowOtpInput(true);
        console.log(showOtpInput);
        console.log('Console');
        setOtpMessage('OTP sent to your email.');
        setEmailError('');
      } else {
        setEmailError(response.data.message || 'Failed to send OTP');
      }
    } catch (error) {
      console.error(error);
      setEmailError(error.response?.data?.message || 'Failed to send OTP. Try again.');
    }
    setError('');
    if (!isValid) return;
  };
  const handleOtpVerify = async () => {
    if (!otp.trim() || otp.length !== 6) {
      // alert('Please enter the OTP');
      showToast('Please enter full 6 numbered OTP', 'error');
      return;
    }
    try {
      const response = await axios.post(
        `${constants.baseUrl}/api/auth/verify-otp`,
        {
          email: emailAdd,
          otp: otp,
        },
        { headers: { 'Content-Type': 'application/json' } }
      );
      if (response.data.message === 'OTP verified successfully') {
        setIsOtpVerified(true);
        setOtpMessage('OTP Verified Successfully!');
      } else {
        // alert(response.data.message || 'Invalid OTP');
        showToast(response.data.message || 'Invalid OTP', 'error');
      }
    } catch (error) {
      console.error('OTP verification failed:', error);
      // alert(error.response?.data?.message || 'OTP verification failed. Please try again.');
      showToast(
        error.response?.data?.message || 'OTP verification failed. Please try again.',
        'error'
      );
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isValid = true;

    // Clear previous errors
    setEmailError('');
    setPhoneError('');
    setNameError('');
    setGenderError('');
    setAadhaarError('');
    setStatusError('');
    setInstitutionError('');
    setFieldOfStudyError('');
    setYearOfStudyError('');
    setCityError('');
    setStateError('');
    setCountryError('');
    setPinCodeError('');
    setWhyJoinError('');
    setHowContributeError('');
    setAreasOfInterestError('');
    setMembershipCategoryError('');
    setPaymentPhotoError('');

    // Validate all fields

    if (name.trim() === '') {
      setNameError('Name cannot be empty');
      isValid = false;
    }
    if (dob.trim() === '') {
      setDobError('Date of Birth cannot be empty');
      isValid = false;
    }
    if (emailAdd.trim() === '') {
      setEmailError('Email cannot be empty');
      isValid = false;
    }

    if (phoneNum.trim() === '') {
      setPhoneError('Phone Number cannot be empty');
      isValid = false;
    }

    if (gender.trim() === '') {
      setGenderError('Gender cannot be empty');
      isValid = false;
    }

    if (!aadhaarCard) {
      setAadhaarError('Aadhaar Number cannot be empty');
      isValid = false;
    }

    // Academic validation
    if (!status.trim()) {
      setStatusError('Please select your current status');
      isValid = false;
    }
    if (institution.trim() === '') {
      setInstitutionError('Institution/Organization cannot be empty');
      isValid = false;
    }
    if (fieldOfStudy.trim() === '') {
      setFieldOfStudyError('Field of Study/Work cannot be empty');
      isValid = false;
    }
    if (yearOfStudy.trim() === '') {
      setYearOfStudyError('Year of Study/Graduation cannot be empty');
      isValid = false;
    }

    // Location validation
    if (city.trim() === '') {
      setCityError('City cannot be empty');
      isValid = false;
    }
    if (state.trim() === '') {
      setStateError('State cannot be empty');
      isValid = false;
    }
    if (country.trim() === '') {
      setCountryError('Country cannot be empty');
      isValid = false;
    }
    if (pinCode.trim() === '') {
      setPinCodeError('Pin Code cannot be empty');
      isValid = false;
    }

    // Motivation validation
    if (whyJoin.trim() === '') {
      setWhyJoinError('Why do you want to join IYNS? cannot be empty');
      isValid = false;
    }
    if (howContribute.trim() === '') {
      setHowContributeError('How would you like to contribute cannot be empty');
      isValid = false;
    }
    if (areasOfInterest.trim() === '') {
      setAreasOfInterestError('Please select an area of interest');
      isValid = false;
    }

    // Membership validation
    if (!membershipCategory) {
      setMembershipCategoryError('Please select a membership category');
      isValid = false;
    }
    if (!paymentPhoto) {
      setPaymentPhotoError('Payment Photo is required.');
      isValid = false;
    }
    setError('');
    if (!isValid) return;

    setIsSubmitting(true);

    const data = new FormData();
    data.append('fullName', name);
    data.append('dateOfBirth', dob);
    data.append('gender', gender);
    data.append('email', emailAdd);
    data.append('mobileNumber', phoneNum);
    data.append('currentStatus', status);
    data.append('institution', institution);
    data.append('field', fieldOfStudy);
    data.append('graduationYear', yearOfStudy);
    data.append('city', city);
    data.append('state', state);
    data.append('country', country);
    data.append('postalCode', pinCode);
    data.append('reasonToJoin', whyJoin);
    data.append('contributionPlan', howContribute);
    data.append('areaOfInterest', areasOfInterest);
    data.append('membershipType', membershipCategory);
    data.append('aadhaarCard', aadhaarCard);
    data.append('membershipPaymentReceipt', paymentPhoto);
    try {
      const response = await axios.post(`${constants.baseUrl}/api/forms/membership`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (response.data.message === 'Form submission received') {
        showToast('Internship form submitted successfully!', 'success');
        setTimeout(() => window.location.reload(), 4000);
      } else {
        // alert(response.data.message || 'Submission failed');
        showToast(response.data.message || 'Submission failed', 'error');
      }
    } catch (err) {
      console.error('Error submitting form:', err.response);
      // alert(err.response?.data?.message || 'Submission failed. Try again.');
      setIsSubmitting(false);
      showToast(err.response?.data?.message || 'Submission failed. Try again.', 'error');
    }
  };

  return (
    <div>
      <Navbar />
      <div className="form-page">
        <div id="form">
          <form onSubmit={handleSubmit}>
            {error && (
              <p style={{ color: 'red' }} className="form-warning">
                {error}
              </p>
            )}

            {/* Personal Details Section */}
            <div className="form-col">
              <div className="form-section form-title-container">
                <p className="form-section-title">Personal Details</p>
                {/* <a
                  href="https://docs.google.com/document/d/1Jp1I5KD3nnxuNz0A7sqi3vnrlayH0ksLHeydYtvx04A/edit?usp=sharing"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="personal-details-link"
                  style={{ marginBottom: '10px' }}
                >
                  View Instructions on how to fill the form
                </a> */}
              </div>
              <div className="form-col">
                <label>Email Address</label>
                <div className="form-row request-otp-row">
                  <input
                    type="text"
                    style={{
                      width: '75%',
                      padding: '8px',
                      marginTop: '4px',
                    }}
                    disabled={isOtpVerified}
                    value={emailAdd}
                    onChange={(e) => setEmailAdd(e.target.value)}
                    placeholder="Enter your Email"
                  />
                  <button type="button" className="request-otp" onClick={handleEmailVerify}>
                    Request OTP
                  </button>
                </div>
                <div className="form-col">
                  {otpMessage && <p style={{ color: 'green', marginTop: '5px' }}>{otpMessage}</p>}
                  <div className="form-row verify-otp-row">
                    {showOtpInput && !isOtpVerified && (
                      <div className="form-col">
                        <label>Enter OTP</label>
                        <div className="form-row verify-otp" style={{ marginTop: '10px' }}>
                          <input
                            type="text"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                            placeholder="Enter the OTP sent to your email"
                            className="verify-otp-input"
                          />
                          <button
                            type="button"
                            className="verify-otp-button"
                            onClick={handleOtpVerify}
                          >
                            Verify OTP
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                  {emailError && <p style={{ color: 'red' }}>{emailError}</p>}
                </div>
              </div>
              <div className="form-row">
                <div className="form-col">
                  <label>Full Name</label>
                  <input
                    type="text"
                    value={name}
                    disabled={!isOtpVerified}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Enter your name"
                  />
                  {nameError && (
                    <p style={{ color: 'red' }} className="form-warning">
                      {nameError}
                    </p>
                  )}
                </div>
                <div className="form-col">
                  <label>Date of Birth</label>
                  <input
                    type="date"
                    max={maxAllowedDate}
                    value={dob}
                    onChange={(e) => setDob(e.target.value)}
                    disabled={!isOtpVerified}
                    placeholder="Enter your Date of Birth"
                  />
                  {nameError && (
                    <p style={{ color: 'red' }} className="form-warning">
                      {dobError}
                    </p>
                  )}
                </div>
                <div className="form-col">
                  <label>Gender</label>
                  <select
                    value={gender}
                    onChange={(e) => setGender(e.target.value)}
                    disabled={!isOtpVerified}
                  >
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                  {genderError && (
                    <p style={{ color: 'red' }} className="form-warning">
                      {genderError}
                    </p>
                  )}
                </div>
              </div>

              {/* Email and Phone Number */}
              <div className="form-row">
                <div className="form-col">
                  <label>Phone Number</label>
                  <input
                    type="text"
                    value={phoneNum}
                    onChange={(e) => setPhoneNum(e.target.value)}
                    disabled={!isOtpVerified}
                    placeholder="Enter your phone number"
                  />
                  {phoneError && (
                    <p style={{ color: 'red' }} className="form-warning">
                      {phoneError}
                    </p>
                  )}
                </div>
                <div className="form-col">
                  <label>Aadhaar Card</label>
                  <input
                    type="file"
                    accept="image/*, .pdf"
                    class="file-input"
                    name="mypayment"
                    onChange={(e) => setAadhaarCard(e.target.files[0])}
                    disabled={!isOtpVerified}
                  ></input>
                  {aadhaarError && (
                    <p style={{ color: 'red' }} className="form-warning">
                      {aadhaarError}
                    </p>
                  )}
                </div>
              </div>
            </div>

            {/* Academic/Professional Details */}
            <div className="form-col">
              <p className="form-section-title">Academic/Professional Details</p>
              <div className="form-row">
                <div className="form-col">
                  <label>Current Status</label>
                  <select
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    disabled={!isOtpVerified}
                  >
                    <option value="">Select status</option>
                    <option value="Student">Student</option>
                    <option value="Researcher">Researcher</option>
                    <option value="Professional">Professional</option>
                    <option value="Other">Other</option>
                  </select>
                  {statusError && (
                    <p style={{ color: 'red' }} className="form-warning">
                      {statusError}
                    </p>
                  )}
                </div>
                <div className="form-col">
                  <label>Institution/Organization</label>
                  <input
                    type="text"
                    value={institution}
                    onChange={(e) => setInstitution(e.target.value)}
                    placeholder="Enter your institution/organization"
                    disabled={!isOtpVerified}
                  />
                  {institutionError && (
                    <p style={{ color: 'red' }} className="form-warning">
                      {institutionError}
                    </p>
                  )}
                </div>
              </div>
              <div className="form-row">
                <div className="form-col">
                  <label>Field of Study/Work</label>
                  <input
                    type="text"
                    value={fieldOfStudy}
                    onChange={(e) => setFieldOfStudy(e.target.value)}
                    placeholder="Enter your field of study/work"
                    disabled={!isOtpVerified}
                  />
                  {fieldOfStudyError && (
                    <p style={{ color: 'red' }} className="form-warning">
                      {fieldOfStudyError}
                    </p>
                  )}
                </div>
                <div className="form-col">
                  <label>Year of Study/Graduation</label>
                  <input
                    type="number"
                    max={2400}
                    value={yearOfStudy}
                    onChange={(e) => setYearOfStudy(e.target.value)}
                    placeholder="Enter your year of study/graduation"
                    disabled={!isOtpVerified}
                  />
                  {yearOfStudyError && (
                    <p style={{ color: 'red' }} className="form-warning">
                      {yearOfStudyError}
                    </p>
                  )}
                </div>
              </div>
            </div>

            {/* Location Details */}
            <div className="form-col">
              <p className="form-section-title">Location Details</p>
              <div className="form-row">
                <div className="form-col">
                  <label>City</label>
                  <input
                    type="text"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                    placeholder="Enter your city"
                    disabled={!isOtpVerified}
                  />
                  {cityError && (
                    <p style={{ color: 'red' }} className="form-warning">
                      {cityError}
                    </p>
                  )}
                </div>
                <div className="form-col">
                  <label>State</label>
                  <input
                    type="text"
                    value={state}
                    onChange={(e) => setState(e.target.value)}
                    placeholder="Enter your state"
                    disabled={!isOtpVerified}
                  />
                  {stateError && (
                    <p style={{ color: 'red' }} className="form-warning">
                      {stateError}
                    </p>
                  )}
                </div>
              </div>
              <div className="form-row">
                <div className="form-col">
                  <label>Country</label>
                  <input
                    type="text"
                    value={country}
                    onChange={(e) => setCountry(e.target.value)}
                    placeholder="Enter your country"
                    disabled={!isOtpVerified}
                  />
                  {countryError && (
                    <p style={{ color: 'red' }} className="form-warning">
                      {countryError}
                    </p>
                  )}
                </div>
                <div className="form-col">
                  <label>Pin Code</label>
                  <input
                    type="number"
                    value={pinCode}
                    onChange={(e) => setPinCode(e.target.value)}
                    placeholder="Enter your pin code"
                    disabled={!isOtpVerified}
                  />
                  {pinCodeError && (
                    <p style={{ color: 'red' }} className="form-warning">
                      {pinCodeError}
                    </p>
                  )}
                </div>
              </div>
            </div>

            {/* Motivation Details */}
            <div className="form-col">
              <p className="form-section-title">Motivation</p>
              <div className="form-row">
                <div className="form-col">
                  <label>Why do you want to join IYNS?</label>
                  <textarea
                    value={whyJoin}
                    onChange={(e) => setWhyJoin(e.target.value)}
                    placeholder="Enter your reason"
                    disabled={!isOtpVerified}
                  />
                  {whyJoinError && (
                    <p style={{ color: 'red' }} className="form-warning">
                      {whyJoinError}
                    </p>
                  )}
                </div>
                <div className="form-col">
                  <label>How would you like to contribute?</label>
                  <textarea
                    value={howContribute}
                    onChange={(e) => setHowContribute(e.target.value)}
                    placeholder="Enter how you would contribute"
                    disabled={!isOtpVerified}
                  />
                  {howContributeError && (
                    <p style={{ color: 'red' }} className="form-warning">
                      {howContributeError}
                    </p>
                  )}
                </div>
              </div>
              <div className="form-row">
                <div className="form-col">
                  <label>Areas of Interest</label>
                  <select
                    value={areasOfInterest}
                    onChange={(e) => setAreasOfInterest(e.target.value)}
                    disabled={!isOtpVerified}
                  >
                    <option value="">Select your area of interest</option>
                    <option value="Nuclear Science and Technology">
                      Nuclear Science & Technology
                    </option>
                    <option value="Climate and Energy Policy">Climate & Energy Policy</option>
                    <option value="Communication and Outreach">Communication & Outreach</option>
                    <option value="Innovation and Start-ups">Innovation & Start-ups</option>
                    <option value="International Collaboration">International Collaboration</option>
                    <option value="Other">Others</option>
                  </select>
                  {areasOfInterestError && (
                    <p style={{ color: 'red' }} className="form-warning">
                      {areasOfInterestError}
                    </p>
                  )}
                </div>
                <div className="form-col">
                  <label for="mypayment">Payment Verification</label>
                  <input
                    type="file"
                    accept="image/*, .pdf"
                    class="file-input"
                    name="mypayment"
                    onChange={(e) => setPaymentPhoto(e.target.files[0])}
                    disabled={!isOtpVerified}
                  ></input>
                  {paymentPhotoError && (
                    <p style={{ color: 'red' }} className="form-warning">
                      {paymentPhotoError}
                    </p>
                  )}
                </div>
              </div>
            </div>

            {/* Membership Category */}
            <div className="form-col">
              <p className="form-section-title">Membership</p>
              <div className="form-row">
                <div className="form-col">
                  <label>Membership Category</label>
                  <select
                    value={membershipCategory}
                    onChange={(e) => setMembershipCategory(e.target.value)}
                    disabled={!isOtpVerified}
                  >
                    <option value="">Select membership category</option>
                    <option value="Annual">Annual</option>
                    <option value="Lifetime">Lifetime</option>
                  </select>
                  {membershipCategoryError && (
                    <p style={{ color: 'red' }} className="form-warning">
                      {membershipCategoryError}
                    </p>
                  )}
                </div>
              </div>
            </div>

            {/* Submit Button */}
            <div className="form-col submit-button-col">
              <button
                type="submit"
                className="form-submit-button"
                onClick={handleSubmit}
                disabled={isSubmitting}
                style={{
                  opacity: isSubmitting ? 0.6 : 1,
                  cursor: isSubmitting ? 'not-allowed' : 'pointer',
                }}
              >
                {isSubmitting ? 'Submitting...' : 'Submit'}
              </button>
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default MembershipForm;
